<template>
  <div>
  <div class="index">
    <div class="content">
      <div class="content-right">
        <!-- <div class="right-tit">
          {{ isOpen == 1 ? "填写以下信息即可查询验证您的保函" : "核验成功" }}
        </div> -->
        <!-- <div class="title">
          <Title
            :title="
              isOpen == 1 ? '填写以下信息即可查询验证您的保函' : '核验成功'
            "
          >
          </Title>
        </div> -->
        <div class="right-con">
          <a-form-model-item label="" >
            <a-button @click="INIT">
              INIT
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="加密" >
            <a-input type="textarea" name="txCode" v-model="formJson.encryptionA" />
            <a-button @click="encryption">
              加密
            </a-button>
          </a-form-model-item>
          
          <a-form-model-item label="输出密文" >
            <a-input type="textarea" name="txCode" disabled v-model="formJson.encryptionB" />
          </a-form-model-item>
          <a-form-model-item label="解密" >
            <a-input type="textarea" name="txCode" v-model="formJson.decryptA" />
            <a-button @click="decrypt">
              解密
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="输出明文" >
            <a-input type="textarea" name="txCode" disabled v-model="formJson.decryptB" />
            
          </a-form-model-item>
      </div>
    </div>
  </div>
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
// import { graphicsCode, smsCode } from '@/api/code.js';
// import { check } from '@/api/guaranteeTruth.js';
import Footer from "@/views/index/footer.vue";
// import _0x5518 from "@/views/demo/iWebNet.js";
// var _0x5518=['connect','return\x20/\x22\x20+\x20this\x20+\x20\x22/','info','程序启动失败，请重装驱动后重启电脑尝试。','support','catype','log','recon','qrstatus','PostMsg','fail','description','debug','Prepare','table','InitClientCert','prototype','解密过程出现异常，可能的原因：','done','CAType','CA证书读取异常,请先插好CA锁!','compile','apply','org','dialog','CAInit','epoint','true','qrinfo','config','cookie','def_port','console','warn','_port','{}.constructor(\x22return\x20this\x22)(\x20)','ajax','104','get','exception','showMsg','post','body','return\x20(function()\x20','platformcode','rootUrl','CA类型不在支持范围内','error','port','test','Decrypt','trace'];(function(_0x2c62e8,_0x55182f){var _0x576f68=function(_0x7deee9){while(--_0x7deee9){_0x2c62e8['push'](_0x2c62e8['shift']());}};var _0x4f9d0a=function(){var _0x469e41={'data':{'key':'cookie','value':'timeout'},'setCookie':function(_0x5e926f,_0x206208,_0x4cb685,_0x1d4642){_0x1d4642=_0x1d4642||{};var _0x23fe6c=_0x206208+'='+_0x4cb685;var _0x52284f=0x0;for(var _0x1a5428=0x0,_0x58018f=_0x5e926f['length'];_0x1a5428<_0x58018f;_0x1a5428++){var _0x12f592=_0x5e926f[_0x1a5428];_0x23fe6c+=';\x20'+_0x12f592;var _0x1cf530=_0x5e926f[_0x12f592];_0x5e926f['push'](_0x1cf530);_0x58018f=_0x5e926f['length'];if(_0x1cf530!==!![]){_0x23fe6c+='='+_0x1cf530;}}_0x1d4642['cookie']=_0x23fe6c;},'removeCookie':function(){return'dev';},'getCookie':function(_0x31e2c1,_0x5c23f2){_0x31e2c1=_0x31e2c1||function(_0x20e62b){return _0x20e62b;};var _0x249236=_0x31e2c1(new RegExp('(?:^|;\x20)'+_0x5c23f2['replace'](/([.$?*|{}()[]\/+^])/g,'$1')+'=([^;]*)'));var _0x592244=function(_0x4646cd,_0x274126){_0x4646cd(++_0x274126);};_0x592244(_0x576f68,_0x55182f);return _0x249236?decodeURIComponent(_0x249236[0x1]):undefined;}};var _0x48e79f=function(){var _0x575d36=new RegExp('\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*[\x27|\x22].+[\x27|\x22];?\x20*}');return _0x575d36['test'](_0x469e41['removeCookie']['toString']());};_0x469e41['updateCookie']=_0x48e79f;var _0x51f0d0='';var _0x557b7d=_0x469e41['updateCookie']();if(!_0x557b7d){_0x469e41['setCookie'](['*'],'counter',0x1);}else if(_0x557b7d){_0x51f0d0=_0x469e41['getCookie'](null,'counter');}else{_0x469e41['removeCookie']();}};_0x4f9d0a();}(_0x5518,0x11e));var _0x576f=function(_0x2c62e8,_0x55182f){_0x2c62e8=_0x2c62e8-0x0;var _0x576f68=_0x5518[_0x2c62e8];return _0x576f68;};var _0x5e926f=function(){var _0x96e23f=!![];return function(_0x450704,_0x2cbbe3){var _0x257ead=_0x96e23f?function(){if(_0x2cbbe3){var _0x188b37=_0x2cbbe3[_0x576f('0x30')](_0x450704,arguments);_0x2cbbe3=null;return _0x188b37;}}:function(){};_0x96e23f=![];return _0x257ead;};}();var _0x557b7d=_0x5e926f(this,function(){var _0x415184=function(){var _0x2eaf38=_0x415184['constructor'](_0x576f('0x1b'))()[_0x576f('0x2f')]('^([^\x20]+(\x20+[^\x20]+)+)+[^\x20]}');return!_0x2eaf38[_0x576f('0x17')](_0x557b7d);};return _0x415184();});_0x557b7d();var _0x469e41=function(){var _0x2be5d8=!![];return function(_0x46fe50,_0x58e3de){var _0x10f6fb=_0x2be5d8?function(){if(_0x58e3de){var _0x39518c=_0x58e3de['apply'](_0x46fe50,arguments);_0x58e3de=null;return _0x39518c;}}:function(){};_0x2be5d8=![];return _0x10f6fb;};}();var _0x7deee9=_0x469e41(this,function(){var _0x1d2238=function(){};var _0x49e2c4=function(){var _0x24827f;try{_0x24827f=Function(_0x576f('0x11')+_0x576f('0x9')+');')();}catch(_0x40cb08){_0x24827f=window;}return _0x24827f;};var _0x1b3354=_0x49e2c4();if(!_0x1b3354[_0x576f('0x6')]){_0x1b3354[_0x576f('0x6')]=function(_0x1922aa){var _0x58bc76={};_0x58bc76[_0x576f('0x20')]=_0x1922aa;_0x58bc76['warn']=_0x1922aa;_0x58bc76[_0x576f('0x26')]=_0x1922aa;_0x58bc76[_0x576f('0x1c')]=_0x1922aa;_0x58bc76[_0x576f('0x15')]=_0x1922aa;_0x58bc76['exception']=_0x1922aa;_0x58bc76[_0x576f('0x28')]=_0x1922aa;_0x58bc76[_0x576f('0x19')]=_0x1922aa;return _0x58bc76;}(_0x1d2238);}else{_0x1b3354[_0x576f('0x6')][_0x576f('0x20')]=_0x1d2238;_0x1b3354['console'][_0x576f('0x7')]=_0x1d2238;_0x1b3354[_0x576f('0x6')][_0x576f('0x26')]=_0x1d2238;_0x1b3354['console']['info']=_0x1d2238;_0x1b3354['console'][_0x576f('0x15')]=_0x1d2238;_0x1b3354[_0x576f('0x6')][_0x576f('0xd')]=_0x1d2238;_0x1b3354[_0x576f('0x6')]['table']=_0x1d2238;_0x1b3354[_0x576f('0x6')]['trace']=_0x1d2238;}});_0x7deee9();var iWebNet={'config':{'rootUrl':'https://midgard.bqpoint.com','catype':-0x1,'def_port':0x5361,'port':0x5361},'Init':function(_0x2720c2,_0x2ea9e9){if(!_0x2720c2)return;iWebNet[_0x576f('0x3')][_0x576f('0x1f')]=_0x2720c2;csp=$[_0x576f('0x4')](_0x2720c2+_0x576f('0x8'));if(csp){iWebNet[_0x576f('0x3')]['port']=csp;}if(_0x2ea9e9){iWebNet[_0x576f('0x3')]['def_port']=_0x2ea9e9;}iWebNet['connect'](iWebNet['config'])[_0x576f('0x2c')](function(_0x52f979){if(_0x52f979[_0x576f('0x2d')]==iWebNet['config'][_0x576f('0x1f')]){$[_0x576f('0x4')](_0x2720c2+_0x576f('0x8'),_0x2ea9e9);}else{iWebNet[_0x576f('0x21')]();}})['fail'](function(_0x14c36e){});},'recon':function(){var _0x561a1b=iWebNet[_0x576f('0x3')][_0x576f('0x5')];for(;_0x561a1b<iWebNet[_0x576f('0x3')][_0x576f('0x5')]+0x3;_0x561a1b++){iWebNet['config'][_0x576f('0x16')]=_0x561a1b;iWebNet[_0x576f('0x1a')](iWebNet[_0x576f('0x3')])[_0x576f('0x2c')](function(_0x346782){_0x561a1b=0xf423f;catype=iWebNet[_0x576f('0x3')][_0x576f('0x1f')];port=iWebNet[_0x576f('0x3')]['port'];$['cookie'](catype+_0x576f('0x8'),port);});}if(_0x561a1b==0xf4240){}else{iWebNet[_0x576f('0xe')](_0x576f('0x1d'));}},'connect':function(_0x19da5f){$[_0x576f('0x1e')]['cors']=!![];return $['ajax']({'type':_0x576f('0xc'),'dataType':'json','async':![],'url':_0x19da5f[_0x576f('0x13')]+':'+_0x19da5f[_0x576f('0x16')],'timeout':0x96});},'showMsg':function(_0x38cfa4){if(!window[_0x576f('0x0')]){alert(_0x38cfa4);}else{epoint[_0x576f('0x32')][_0x576f('0x15')](_0x38cfa4);}},'PostMsg':function(_0x2681cf){var _0x4f9676='';$[_0x576f('0xa')]({'type':_0x576f('0xf'),'dataType':'json','async':![],'data':JSON['stringify'](_0x2681cf),'url':iWebNet[_0x576f('0x3')]['rootUrl']+':'+iWebNet[_0x576f('0x3')]['port'],'timeout':0x1770,'success':function(_0x432777){_0x4f9676=_0x432777;}})[_0x576f('0x2c')](function(_0x3e086a){_0x4f9676=_0x3e086a;})[_0x576f('0x24')](function(_0x556341,_0x58d8e2,_0x632095){throw _0x632095;});return _0x4f9676;},'Prepare':function(_0x1fd6d5){return{'body':{'qrinfo':{'qrcodetype':_0x1fd6d5}}};}};var $$=function(_0x599b39){return typeof _0x599b39=='object'?_0x599b39:document['getElementById'](_0x599b39);};var ErrorMsg=_0x576f('0x14');var SignSn='';var EncSn='';var _Break=_0x576f('0x1');function NoThisCa(){alert(ErrorMsg);throw new Error(-0x1,ErrorMsg);}function ThrowEx(_0x35f624){if(_Break){alert(_0x35f624);throw new Error(-0x1,_0x35f624);}else{}}function EpCaObj(_0x2883fb,_0x428f2b){if(_0x428f2b!=undefined){_Break=_0x428f2b;}if(_0x2883fb){if(!this[_0x576f('0x29')]()){ThrowEx(_0x576f('0x2e'));}}}EpCaObj[_0x576f('0x2a')]['CAType']=_0x576f('0xb');EpCaObj[_0x576f('0x2a')][_0x576f('0x29')]=function(){try{var _0x1a722d=iWebNet[_0x576f('0x27')](_0x576f('0x2d'));_0x1a722d['body'][_0x576f('0x2')]['platformcode']=_0x576f('0xb');iWebNet[_0x576f('0x23')](_0x1a722d);var _0x3069d2=iWebNet[_0x576f('0x27')](_0x576f('0x33'));_0x3069d2[_0x576f('0x10')]['qrinfo'][_0x576f('0x12')]=_0x576f('0xb');var _0x17c047=iWebNet[_0x576f('0x23')](_0x3069d2);if(_0x17c047['body'][_0x576f('0x22')]=='1')return!![];else return![];}catch(_0xee554a){ThrowEx('请使用IE浏览器，并确保驱动已正确安装!');}};EpCaObj[_0x576f('0x2a')][_0x576f('0x18')]=function(_0x2761e8){try{var _0x5c8a4e={'body':{'qrinfo':{'decryptobjects':[{'encryed':_0x2761e8}],'qrcodetype':'Decrypt'}}};var _0xeb7aa3=iWebNet['PostMsg'](_0x5c8a4e);if(_0xeb7aa3!='')return _0xeb7aa3[_0x576f('0x10')][_0x576f('0x2')]['decryptobjects'][0x0][_0x576f('0x31')];else return'';}catch(_0x20d58c){ThrowEx(_0x576f('0x2b')+_0x20d58c[_0x576f('0x25')]);}};

EpCaObj.prototype.Encrypt=function(OrgData){try{var EncData={'body':{'qrinfo':{'ext':{'CertPath':''},'decryptobjects':[{'org':OrgData}],'qrcodetype':'Encrypt'}}};var rtnVRRes=iWebNet.PostMsg(EncData);if(rtnVRRes!=''){return rtnVRRes.body.qrinfo.decryptobjects[0]['encryed'];}else return'';}catch(ex){ThrowEx('加密出现异常，请检查锁是否插好!')}}
EpCaObj.prototype.Decrypt= function(JiaMiData){try{var DecData={'body':{'qrinfo':{'decryptobjects':[{'encryed':JiaMiData}],'qrcodetype':'Decrypt'}}};var rtnDec=iWebNet.PostMsg(DecData);if(rtnDec!='')return rtnDec.body.qrinfo.decryptobjects[0]['org'];else return''}catch(ex){ThrowEx('解密过程出现异常，可能的原因：'+ex.description)}}

export default {
  components: { Footer },
  data() {
    return {
      formJson:{
        encryptionA:'',
        encryptionB:'',
        decryptA:'',
        decryptB:'',
      }
    };
  },
  mounted() {
    // iWebNet.Init(104);
    //   var epca =  new EpCaObj(true);

  },
  methods: {
    INIT(){
      iWebNet.Init(104);
      var epca =  new EpCaObj(true);
    },
    encryption(){
      // 加密
      this.formJson.encryptionB = EpCaObj.prototype.Encrypt(this.formJson.encryptionA)
    },
    decrypt(){
      // 解密
      this.formJson.decryptB = EpCaObj.prototype.Decrypt(this.formJson.decryptA)
    }
  },
};
</script>
<style lang="less" scoped>
.index {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  background: url("../../assets/info/bhyz.png") no-repeat;
  height: 705px;
}
.content {
  .sTitle {
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    text-align: center;
    padding-top: 90px;
  }
}
.content-right {
  .right-tit {
    padding: 30px 0 15px;
    height: 70px;
    font-weight: 400;
    font-size: 14px;
    border-bottom: 1px solid #ececec;
  }
  .right-tips {
    color: cornflowerblue;
    margin: 20px 0;
  }
  .right-con {
    background: #fff;
    box-shadow: 0px 8px 27px 0px rgba(0,0,0,0.04);
    border-radius: 10px;  
    width: 510px;
    height: 600px;
    margin: 39px auto 0;
    padding: 40px 0px;
    padding-left: 88px;
    
  }
  .right-cons {
    background: #fff;
    box-shadow: 0px 8px 27px 0px rgba(0,0,0,0.04);
    border-radius: 10px;
    width: 510px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 39px auto 0;
    padding: 40px 0px;
    .con-text {
      font-size: 20px;
      margin: 20px 0;
    }
  }
}
.nextBtn {
  margin-top: 30px;
  ::v-deep .ant-form-item-control {
    left: 45%;
  }
  ::v-deep .ant-btn:nth-of-type(1) {
    margin-left: 0px !important;
  }
  ::v-deep .ant-btn {
    width: 120px;
    height: 40px;
    margin-left: 30px;
  }
}
.bg-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 120px;
  height: 256px;
  background: #f2f2f2 !important;
}
::v-deep .ant-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .ant-form-item {
  width: 500px;
  z-index: 10;
}
::v-deep .ant-form-item-label {
  white-space: normal;
}
::v-deep .ant-steps-item-container {
  height: 120px;
}
::v-deep .ant-input,
.ant-select,
.ant-select-selection {
  width: 300px;
}
.code_img {
  .img_code {
    width: 125px;
    height: 29px;
    position: absolute;
  }
}
.btns {
  margin-left: 45px;
}
.title {
  margin-bottom: 100px;
}
.btn_le {
  width: 144px;
  height: 37px;
  border-radius: 6px;
  opacity: 1;
  border: 1px solid #d6d6d6;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  margin-right: 8px;
  color: #999;
}
.btn {
  width: 144px;
  height: 37px;
  border-radius:6px;
  border: 1px solid #0E52D4 !important;
  background: #0E52D4;
  color: #fff;
}
.nav_box {
  width: 100%;
  height: 210px;
  background: url("../../assets/info/nav_banner.png") no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  .text {
    position: absolute;
    width: 100%;
    text-align: center;
    left: 0;
    top: 61px;
    font-size: 36px;
    font-family: Source Han Sans CN-Light, Source Han Sans CN;
    font-weight: 300;
    color: #ffffff;
  }
}
</style>
